import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Palette, Code, Camera, Zap } from 'lucide-react';
const services = [{
  icon: <Palette className="w-8 h-8" data-id="element-246" />,
  title: 'Branding',
  description: 'We build brands that speak louder. Logos, visual identity, and brand strategy that cuts through the noise.'
}, {
  icon: <Code className="w-8 h-8" data-id="element-247" />,
  title: 'Digital',
  description: 'Websites and applications that are fast, responsive, and built with the latest technology.'
}, {
  icon: <Camera className="w-8 h-8" data-id="element-248" />,
  title: 'Content',
  description: 'Photography, copywriting, and art direction that tells your story with authenticity.'
}, {
  icon: <Zap className="w-8 h-8" data-id="element-249" />,
  title: 'Motion',
  description: 'Bringing static designs to life with smooth animations and interactive experiences.'
}];
export function Studio() {
  return <div className="min-h-screen bg-black text-white selection:bg-yellow-400 selection:text-black" data-id="element-250">
      <SEO title="Tentang Kami | KUJODO Creative Studio Cimahi, Bandung" description="KUJODO adalah creative studio di Cimahi, Bandung yang berfokus pada branding, digital, content, dan motion design. Kami membantu brand lokal tampil bold dan berkesan." keywords="creative studio Cimahi, creative studio Bandung, tentang KUJODO, studio desain kreatif Bandung, branding agency Cimahi Bandung" canonical="https://kujodo.id/studio" data-id="element-251" />
      <Navigation data-id="element-252" />

      <main className="pt-32 pb-24" data-id="element-253">
        {/* Hero / About */}
        <section className="px-6 mb-32" data-id="element-254">
          <div className="max-w-7xl mx-auto" data-id="element-255">
            <h1 className="text-6xl md:text-9xl font-black tracking-tighter mb-12" data-id="element-256">
              WE ARE <br data-id="element-257" />
              <span className="text-yellow-400" data-id="element-258">KUJODO</span>
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-259">
              <div className="text-2xl md:text-3xl font-bold leading-tight" data-id="element-260">
                We are a creative studio obsessed with bold ideas and flawless
                execution. We don't just design; we define.
              </div>
              <div className="text-gray-400 text-lg leading-relaxed space-y-6" data-id="element-261">
                <p data-id="element-262">
                  Founded in Cimahi, KUJODO was born from a desire to break the
                  mold of traditional agencies. We believe that great design
                  shouldn't just look good—it should provoke, inspire, and drive
                  results.
                </p>
                <p data-id="element-263">
                  Our team is a collective of designers, developers, and
                  strategists who share a common goal: to create digital
                  experiences that people actually remember. We work with brands
                  that aren't afraid to stand out.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Services */}
        <section className="px-6 py-24 bg-gray-900/30 border-y border-white/10 mb-32" data-id="element-264">
          <div className="max-w-7xl mx-auto" data-id="element-265">
            <h2 className="text-yellow-400 font-bold tracking-widest uppercase mb-16" data-id="element-266">
              Our Expertise
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-267">
              {services.map((service, index) => <div key={index} className="group" data-id="element-268">
                  <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mb-6 text-yellow-400 group-hover:bg-yellow-400 group-hover:text-black transition-colors duration-300" data-id="element-269">
                    {service.icon}
                  </div>
                  <h3 className="text-2xl font-bold mb-4" data-id="element-270">{service.title}</h3>
                  <p className="text-gray-400 group-hover:text-gray-300 transition-colors" data-id="element-271">
                    {service.description}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="px-6" data-id="element-272">
          <div className="max-w-7xl mx-auto bg-yellow-400 text-black p-12 md:p-24 text-center" data-id="element-273">
            <h2 className="text-4xl md:text-7xl font-black uppercase tracking-tighter mb-8" data-id="element-274">
              Have an idea?
            </h2>
            <p className="text-xl md:text-2xl font-bold mb-12 max-w-2xl mx-auto" data-id="element-275">
              Let's turn your vision into a reality. We are currently accepting
              new projects for Q2 2024.
            </p>
            <Link to="/contact" data-id="element-276">
              <button className="bg-black text-white px-10 py-5 font-bold uppercase tracking-widest hover:bg-white hover:text-black transition-colors text-lg" data-id="element-277">
                Start a Project
              </button>
            </Link>
          </div>
        </section>
      </main>

      <Footer data-id="element-278" />
    </div>;
}